$(document).ready(function() {

    // Kinderfeld ggf. entfernen
    // Formular abschicken
    $("#ttgBookingBoxSubmitBtn").click(function() {
        if ($("#children").val() == "") {
            $("#children").remove();
        }
        $("#ttgBuchenForm").submit();
    });

    var $form = $('#ttgBuchenForm');

    var now = new Date();

    $form.find('#anreiseDatum').datepicker({
            format: 'dd.mm.yyyy',
            weekStart: 1,
            language: 'de',
            todayHighlight: true,
            startDate: now,
            endDate: new Date(new Date().setFullYear(now.getFullYear() + 2)),
        })
        .datepicker("setDate", now)
        .on("changeDate", function(e) {
            var dTmp = $(this).datepicker("getDate");
            var theDate = dTmp.getFullYear() + ('0' + (dTmp.getMonth() + 1)).slice(-2) + ('0' + dTmp.getDate()).slice(-2);
            $("#selArrivalDate").val(theDate);
        })
        .datepicker("update");

    function getArrivalDate(dateText) {
        var anreiseDatumTmp = selectedDate;
        var anreiseDatumString = anreiseDatumTmp.split(".");
        $("#selArrivalDate").val(anreiseDatumString[2] + anreiseDatumString[1] + anreiseDatumString[0]);

    }

});